import React from "react";
import styled, { ThemeProvider } from "styled-components";

import { SubscribeToNewsletterModal } from "./SubscribeToNewsletterModal";
import { DevRefreshButton } from "./DevRefreshButton";
import { theme } from "../styles/theme";
import { newsletterOffers } from "../services/newsletter-offers";
import "../styles/global.css";
import "../styles/utils.css";

const MainContainer = styled.main`
  &:not(.home) {
    padding-top: 120px;
  }
`;

const Layout = ({ children, className }) => {
  // const newsletterOffer = newsletterOffers?.travelCase;
  //const newsletterOffer = newsletterOffers?.discount;
  const newsletterOffer = newsletterOffers?.discountV2;
  // const newsletterOffer = newsletterOffers?.freeShipping;

  return (
    <ThemeProvider theme={theme}>
      <MainContainer id="main-container" className={className}>
        {newsletterOffer ? (
          <SubscribeToNewsletterModal {...newsletterOffer} />
        ) : null}
        <DevRefreshButton />
        {children}
      </MainContainer>
    </ThemeProvider>
  );
};

export default Layout;
